import AzureActiveDirectoryLoginProvider from 'Lib/Services/AzureActiveDirectoryLoginProvider';
import UserListLoginProvider from 'Lib/Services/UserListLoginProvider';
import type LoginProvider from 'Lib/LoginProvider';

export const LoginProvidersMap: { [key: string]: (config?: any) => Promise<LoginProvider> } = {
    [AzureActiveDirectoryLoginProvider.staticKey]: async (config?: any) => await AzureActiveDirectoryLoginProvider.create(config),
    [UserListLoginProvider.staticKey]: async (config?: any) => new UserListLoginProvider(),
};
